<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Reparto </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salva" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <!-- Campi di testo con i dettagli del reparto -->
    <v-card-text>
      <v-row class="mt-5 pb-0" dense>
        <v-col cols="6">
          <v-autocomplete
            dense
            :items="sedi"
            label="Sede"
            item-text="descrizione"
            item-value="id_azienda_sede"
            v-model="id_sede"
          >
            {{ id_sede }}
          </v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            class="ml-5"
            v-model="reparto.descrizione"
            type="text"
            label="Nome reparto"
          />
        </v-col>
      </v-row>
      <v-row align="start" justify="center" dense>
        <v-col cols="4">
          <Macchine
            :id_reparto="reparto.id_azienda_sede_reparto"
            ref="macchine"
        /></v-col>
        <v-col cols="8">
          <Squadre :reparto="reparto" ref="squadre" />
        </v-col>
      </v-row>
    </v-card-text>
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import Macchine from "@/components/PRODUCTION/Impostazioni/Macchine.vue";
import Squadre from "@/components/PRODUCTION/Impostazioni/Squadre.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: {
    Macchine,
    Squadre,
    SnackbarQV
  },

  props: ["reparto"],

  data() {
    return {
      // Variabili d'appoggio
      id_sede: this.reparto.id_azienda_sede,

      // Modal

      // Array
      sedi: new Array(),
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    addTeam() {
      console.log("add team");
    },

    clickChiudi() {
      this.$emit("click_chiudi_dettaglio");
    },

    getSedi() {
      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedi",
          id_azienda: 1,
          id_azienda_sede: null,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.sedi = res.data.result ? res.data.result : [];
            console.log(this.sedi);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    salva() {
      this.$refs.macchine.aggiungiMacchina();
      this.$refs.macchine.rimuoviMacchina();
      this.$refs.squadre.saveSquadre();

      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.user_token,
          action: "saveaziendasedereparto",
          reparto: [{
            id_azienda_sede_reparto: this.reparto.id_azienda_sede_reparto,
            id_azienda_sede: this.id_sede,
            descrizione: this.reparto.descrizione,
            validita: 1
          }],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200 || res.status == 204) {
          this.$emit("salvataggio_reparto");
          this.clickChiudi();
          return;
        }
      });
    },
  },

  created() {},

  mounted() {
    this.getSedi();
  },
};
</script>

<style scoped>
</style>